import { TabList, TabPanel } from "@mui/lab";
import {
  Accordion,
  Checkbox,
  Dialog,
  Grid2,
  LinearProgress,
  Table,
  TableCell,
  TableContainer,
  Tooltip,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";

export const StyledFlexRowView = styled("div")(({ alignItems, gap }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: alignItems || "center",
  gap: gap || "10px",
}));

export const StyledFlexColumnView = styled("div")(({ gap }) => ({
  display: "flex",
  flexDirection: "column",
  //   alignItems: "center",
  gap: gap || "10px",
}));

export const StyledCheckBox = styled(Checkbox)(() => ({
  padding: "0px !important",
  color: "#DF1278",
  "&.Mui-checked": {
    color: "#DF1278",
  },
}));

export const StatusChange = styled("div")(
  ({
    color,
    borderRadius,
    background,
    border,
    padding,
    fontWeight,
    fontSize,
    boxShadow = "0px 0px 1px 0px #101828",
  }) => ({
    border: border || "1px solid #D0D5DD",
    color: color || "#344054",
    width: "max-content",
    display: "flex",
    alignItems: "center",
    borderRadius: borderRadius || "5px",
    padding: padding || "2px 5px",
    gap: "5px",
    boxShadow: { boxShadow },
    fontSize: fontSize || "13px",
    background: background,
    fontWeight: fontWeight,
  })
);

export const ScoreChange = styled("div")(
  ({ margin, background, color, border }) => ({
    border: border || "1px solid #ABEFC6",
    color: color || "#067647",
    width: "max-content",
    display: "flex",
    alignItems: "center",
    borderRadius: "5px",
    padding: "2px 5px",
    gap: "5px",
    background: background || "#ECFDF3",
    fontSize: "13px",
    margin: margin,
  })
);

export const DotColor = styled("div")(
  ({ color, marginRight, width, height }) => ({
    background: color,
    width: width || "7px",
    height: height || "7px",
    borderRadius: "50%",
    marginRight: marginRight,
  })
);

export const TableContainerBorder = styled(TableContainer)(
  ({ marginTop, fontSize, scrollStyle, height, customStyle }) => ({
    border: "1px solid #EAECF0",
    borderRadius: "10px",
    marginTop: marginTop || "2.5rem",
    boxShadow: "0px 1px 2px 2px rgba(16, 24, 40, 0.05)",
    // boxShadow: " 0px 1px 2px 0px #1018280D",
    "& .MuiTableHead-root": {
      backgroundColor: "#F9FAFB",
      "& .MuiTableCell-root": {
        fontSize: fontSize,
      },
    },

    "& .selected-row-color": {
      background: "#F9FAFB",
    },
    ...(scrollStyle && {
      height: height || "auto",
      display: "block",

      "&::-webkit-scrollbar": {
        width: "7px",
        height: "7px",
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },

      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "2px",
      },
    }),

    "& .MuiTableCell-body,.MuiTableCell-head": {
      fontWeight: 500,
      fontFamily: "Inter",
    },

    // "& .MuiTableBody-root": {
    //   "& .MuiTableRow-root": {
    //     "&:nth-of-type(odd)": {
    //       backgroundColor: "#F9FAFB",
    //     },
    //   },
    // },
    "& .MuiPagination-ul": {
      "& .MuiPaginationItem-text": {
        fontWeight: "500",
        fontFamily: "Inter",
      },
      "& .Mui-selected": {
        fontWeight: "600",
        fontFamily: "Inter",
      },
    },
    ...customStyle,
  })
);

export const TabViewSection = styled(TabList)(
  ({
    customStyle,
    padding,
    margin,
    color,
    fontWeight,
    boxShadow,
    minHeight,
    borderRadius,
  }) => ({
    background: "#F9FAFB",
    border: "1px solid #EAECF0",
    borderRadius: borderRadius || "10px",
    gap: "5px",
    maxWidth: "fit-content",
    "& .MuiTabs-flexContainer": {
      width: "-webkit-fill-available",
    },

    "& .MuiTab-root": {
      padding: padding || "0px 2.5rem",
      minHeight: minHeight || "40px",
      color: color || "#667085",
      fontWeight: fontWeight || 600,
      fontFamily: "Inter",
    },
    "& .Mui-selected": {
      background: "#fff",
      margin: "5px",
      color: "#344054 !important",
      boxShadow: boxShadow || "0px 0px 1px 0px #101828",
      borderRadius: "5px",
      fontWeight: "700",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTabScrollButton-horizontal": {
      background: "#ffff !important",
      margin: margin || "7px 7px",
      borderRadius: "7px",
      boxShadow: "0px 0px 1px 0px #101828",
    },
    ...customStyle,
  })
);

export const JudicaTabViewSection = styled(TabList)(() => ({
  width: "100%",

  "& .MuiTabs-flexContainer": {
    width: "-webkit-fill-available",
    flexDirection: "row",
    margin: "1.5px",
    gap: "0.8rem",
  },
  "& .Mui-selected": {
    background: "#EBE1F9",
    color: "#6947B0 !important",
    borderRadius: "5px",
    "& svg path": {
      stroke: "#6947B0",
    },
  },
  "& .MuiTab-root": {
    padding: "10px 1rem",
    minHeight: "32px",
    color: "#667085",
    fontWeight: 600,
    fontFamily: "Inter",
    alignItems: "start",
    flex: 1,
    border: "1px solid #EAECF0",
    borderRadius: "5px",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

export const QuickViewTab = styled(TabList)(() => ({
  width: "100%",

  "& .MuiTabs-flexContainer": {
    width: "-webkit-fill-available",
    margin: "1.5px",
  },
  "& .Mui-selected": {
    background: "#EBE1F9",
    color: "#6947B0 !important",
    borderRadius: "5px",
    "& svg path": {
      stroke: "#6947B0",
    },
  },
  "& .MuiTab-root": {
    padding: "10px 1rem",
    minHeight: "32px",
    color: "#667085",
    fontWeight: 600,
    fontFamily: "Inter",
    alignItems: "start",
    flex: 1,
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

export const JudicaCandidateTabViewSection = styled(TabList)(
  ({
    scrollStyle,
    scrollBar,
    scrollBarRadius,
    overflowY,
    height,
    padding,
    width,
  }) => ({
    overflow: "visible",
    left: "-9px",
    position: "relative",
    height: height,
    minHeight: "auto",

    "& .MuiTabs-flexContainer": {
      width: "-webkit-fill-available",
      margin: "1.5px",
      gap: "5px",
    },
    "& .MuiTabs-scroller": {
      width: "calc(100% + 20px)",
      overflowY: overflowY,
      ...(scrollStyle && {
        "&::-webkit-scrollbar": {
          display: "block",
          width: scrollBar || "7px",
          height: scrollBar || "7px",
        },

        "&::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: scrollBarRadius || "0px",
        },
      }),
    },
    "& .Mui-selected": {
      background: "#EBE1F9",
      color: "#6947B0 !important",
      borderRadius: "5px",
    },
    "& .MuiTab-root": {
      padding: padding || "10px 8px",
      minHeight: "32px",
      color: "#667085",
      fontWeight: 600,
      fontFamily: "Inter",
      alignItems: "start",
      opacity: 1,
      cursor: "pointer",
      minWidth: "100%",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  })
);

export const CreateTabList = styled(TabList)(() => ({
  "& .MuiTab-root": {
    borderTop: "4px solid #EAECF0",
    fontWeight: 600,
    fontFamily: "Inter",
    flexGrow: 1,
    color: "#344054",
    "&:hover": {
      color: "#6941C6",
      fontWeight: "bold",
      borderTop: "4px solid #7F56D9",
    },
  },
  "& .Mui-disabled": {
    color: "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiButtonBase-root": {
    fontSize: "16px",
    maxWidth: "none",
    display: "flex",
    alignItems: "start",
    paddingLeft: "0px",
  },
  "& .MuiTabs-flexContainer": {
    justifyContent: "space-between",
    width: "100%",
    gap: "1rem",
    "& .Mui-selected": {
      color: "#6941C6",
      fontWeight: "bold",
      borderTop: "4px solid #7F56D9",
    },
  },
  "& .MuiTabs-indicator": {
    top: 0,
    height: 3,
  },
}));
export const StyledTableTitleTableCell = styled(TableCell)(
  ({ textAlign, width, minWidth }) => ({
    fontSize: "15px",
    fontWeight: 500,
    color: "#475467",
    fontFamily: "Inter",
    textAlign: textAlign,
    width: width,
    minWidth: minWidth,
  })
);

export const StyledTableBodyTableCell = styled(TableCell)(
  ({ textAlign, fontSize }) => ({
    fontSize: fontSize || "14px",
    fontWeight: 500,
    color: "#101828",
    fontFamily: "Inter",
    textAlign: textAlign,
  })
);

export const StyledTypo = styled(Typography)(() => ({
  fontSize: "15px",
  fontWeight: 500,
  color: "#101828",
  fontFamily: "Inter",
}));

export const StyledTypoGrey = styled(Typography)(() => ({
  fontSize: "14px",
  fontWeight: 500,
  color: "#475467",
  fontFamily: "Inter",
}));

export const TabPanelView = styled(TabPanel)(({ padding, width, height }) => ({
  padding: padding,
  width: width,
  height: height,
}));

export const CommonGrid2 = styled(Grid2)(
  ({
    gap,
    alignItems,
    display,
    justifyContent,
    flexDirection,
    overflowY,
    wordBreak,
    width,
    background,
    padding,
    height,
    scrollStyle,
    cursor,
    borderRadius,
    boxShadow,
    flexWrap,
    scrollBar,
    scrollBarRadius,
    displayBar = "block",
    paddingRight,
    overflowX,
    maxHeight,
    transition,
    right,
    minWidth,
    customStyle,
    flexGrow,
  }) => ({
    flexGrow:flexGrow,
    gap: gap,
    alignItems: alignItems,
    display: display,
    justifyContent: justifyContent,
    flexDirection: flexDirection,
    overflowY: overflowY,
    overflowX: overflowX,
    wordBreak: wordBreak,
    width: width,
    background: background,
    padding: padding,
    height: height,
    maxHeight: maxHeight,
    cursor: cursor,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    transition: transition,
    flexWrap: flexWrap,
    minWidth: minWidth,
    right: right,
    ...(scrollStyle && {
      paddingRight: paddingRight,
      "&::-webkit-scrollbar": {
        display: displayBar,
        width: scrollBar || "7px",
        height: scrollBar || "7px",
      },

      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: scrollBarRadius || "0px",
      },
    }),
    ...customStyle,
  })
);

export const CustomAccordion = styled(Accordion)(
  ({
    borderBottom,
    ContentMargin,
    paddingBottom,
    padding,
    width,
    customStyle,
  }) => ({
    width: width,
    marginTop: "0.5rem",
    padding: "6px 14px !important",
    paddingBottom: paddingBottom || "0.5rem",
    boxShadow: "none",
    borderBottom: borderBottom,
    border: "1px solid #EAECF0",
    borderRadius: "10px !important",
    pointerEvents: "auto !important",

    "&::before": {
      display: "none",
    },
    "& .MuiAccordionSummary-root": {
      padding: "0px",
    },

    "& .MuiAccordionSummary-content": {
      margin: ContentMargin || "12px 0px",
    },
    "& .MuiAccordionDetails-root": {
      padding: padding || "8px",
      marginBottom: "0.5rem",
    },

    "& .MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "50px",
    },
    ...customStyle,
  })
);

export const CustomLinearProgress = styled(LinearProgress)(({ color }) => ({
  flex: 1,
  height: "8px",
  borderRadius: "4px",
  backgroundColor: "#E0E0E0",
  "& .MuiLinearProgress-bar": {
    backgroundColor: color,
  },
}));

export const CustomTooltip = styled(
  ({ className, backgroundColor,maxWidth, borderRadius, border,arrow=true, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow={arrow} />
  )
)(({ backgroundColor, borderRadius,maxWidth, border, ...props }) => ({
  [`& .MuiTooltip-tooltip`]: {
    borderRadius: borderRadius,
    textAlign: props?.textAlign,
    border: border,
    color: "#fff",
    backgroundColor: backgroundColor || "#7F56D9",
    padding: props?.padding || "7px 15px",
    boxShadow: props?.boxShadow,
    fontWeight: props?.fontWeight,
    margin: props?.margin,
    fontSize: props?.fontSize,
     ...(maxWidth && { maxWidth }),
  },
  [`& .MuiTooltip-arrow`]: {
    ...props.arrowHeight,
    "&::before": {
      backgroundColor: backgroundColor || "#7F56D9",
      border: border,
      ...props.beforeArrowHeight,
    },
  },
}));

export const TitleTypo = styled(Typography)(
  ({ fontWeight, textOverflow, overflow, whiteSpace, color, fontSize }) => ({
    fontSize: fontSize || "16px",
    fontWeight: fontWeight || 600,
    color: color || "#475467",
    whiteSpace: whiteSpace,
    overflow: overflow,
    textOverflow: textOverflow,
  })
);

export const SubTitleTypo = styled(Typography)(
  ({ color, fontSize, whiteSpace, overflow, textOverflow }) => ({
    fontSize: fontSize || "16px",
    fontWeight: 600,
    color: color || "#101828",
    whiteSpace: whiteSpace,
    overflow: overflow,
    textOverflow: textOverflow,
  })
);
export const CheckBoxSelected = styled("div")(() => ({
  // padding: "32px 0px 0px 0px",
  fontSize: "20px",
  fontFamily: "Inter",
  fontWeight: 600,
}));
export const StyledDialog = styled(Dialog)(() => ({
  borderRadius: "10px",
  "& .MuiDialog-paper": {
    borderRadius: "12px",
    background: "#FFF",
    boxShadow:
      "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  },
}));

export const DataFound = styled("div")(({ padding, margin }) => ({
  textAlign: "center",
  background: "rgb(105 65 198 / 13%)",
  border: "1px solid rgb(105, 65, 198)",
  width: "max-content",
  margin: margin || "1rem auto",
  fontFamily: "system-ui",
  padding: padding || "0px 10px",
  borderRadius: "5px",
  color: " rgb(105, 65, 198)",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontWeight: 700,
  flexDirection: "row",
}));

export const DialogTableList = styled("div")(
  ({ display, gap, flexWrap, border, padding, borderRadius }) => ({
    display: display,
    gap: gap,
    flexWrap: flexWrap,
    border: border,
    borderRadius: borderRadius,
    padding: padding,
  })
);

export const CustomTable = styled(Table)(() => ({
  borderCollapse: "separate",
  borderSpacing: "10px",
  "& .MuiTableCell-root": {
    border: "1px solid #EAECF0",
    borderRadius: "5px",
    boxShadow: "0px 1px 1px 1px rgba(16, 24, 40, 0.05)",
    padding: "10px",
  },
}));
